<template>
  <div>
    <h1 class="center">ESTUDIANTES</h1>
    <h3 class="center">Personalización</h3>
    <v-container style="">
      <div>
     
      </div>
    </v-container>
  </div>
</template>



<script>
export default {
  components: {
  },
  data() {
    return {
      data: {
        linkWhatsapp: "",
      },
      showMenu: true,
    };
  },
  mounted() {

  },
  created() {

  },
  methods: {


  },
  computed: {
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.centered-input>>>input {
  text-align: center;
}
</style>